export const MyRequirementData = [ 
    {id: 0, name: "Active"},
    {id: 1, name: "Awarded"},
] 